<template>
  <div class="sort-item" :class="{ select: item.select }">
    <div v-html="item.content.richText"></div>
    <div class="sort-right-icon">
      <div class="sort-right-icon--wrap">
        <span v-if="item.select">{{ index + 1 }}</span>
      </div>
    </div>
    <template v-if="item.is_other_item">
      <relation-input
          @click.native.stop
          :type="item.inputType"
          v-model="item.value"
          :option-id="item.id"
          :enable-relation="item.setting.enableRelation"
          :max-length="item.maxLength"
          :min-length="item.minLength"
          :validate="item.validate"
      />
<!--      <van-field @click.native.stop v-model="item.value" placeholder="请输入" />-->
    </template>
  </div>
</template>

<script>
import RelationInput from '../components/RelationInput.vue'

export default {
  name: 'SortItem',
  components: { RelationInput },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: -1
    }
  }
}
</script>

<style scoped></style>
